import { NgxLoggerLevel } from 'ngx-logger';
import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  azure: {
    clientId: '83fa5c9d-c05c-4994-9627-bb6bfe6e5764',
    tenantId: 'f2baf195-6705-441b-912a-3b2997d976fd',
    redirectUri: 'https://irgreview.dev.onrsr.com.au',
  },
  logging: {
    level: NgxLoggerLevel.INFO,
    serverLogLevel: NgxLoggerLevel.WARN,
  },
  apiHost: 'https://nr-ae-sb-irg-review-dev-app-b6egd0hyfjavbwew.australiaeast-01.azurewebsites.net/api',
};
